import {Helmet} from 'react-helmet-async';
import '../components/InformationPage.css';

function ContactPage() {
  return (
    <>
      <Helmet>
        <title>Contact Medical Coding Classes Online | Support</title>
        <meta
          name="description"
          content="Contact Medical Coding Classes Online for platform questions, technical support, content feedback, and general inquiries."
        />
        <link rel="canonical" href="https://medicalcodingclassesonline.com/contact" />
      </Helmet>
      <main className="information-page">
        <section className="information-hero">
          <div className="container">
            <span className="eyebrow">Support and contact</span>
            <h1>How can we help?</h1>
            <p>
              Send the team a message about Medical Coding Classes Online, study content, or
              technical support.
            </p>
          </div>
        </section>
        <section className="information-section">
          <div className="container information-layout">
            <article className="information-content">
              <h2>Contact our support team</h2>
              <p>
                We welcome questions, corrections, suggestions, and feedback about the learning
                experience. Please include enough detail for our team to understand your request.
              </p>
              <form
                className="contact-form"
                data-greta-form="medical-coding-classes-online-contact"
                data-greta-submit-label="Send message"
              />
            </article>
            <aside className="information-aside">
              <span className="aside-label">Direct support</span>
              <h2>Email the team</h2>
              <p>
                For direct assistance, send an email to our support address. We use the same
                routing for platform questions and technical issues.
              </p>
              <a className="contact-email" href="mailto:support@leadsurance.com">
                support@leadsurance.com
              </a>
            </aside>
          </div>
        </section>
      </main>
    </>
  );
}

export default ContactPage;